import { SkeletonLoader } from 'common/react/components/SkeletonLoader';
import React from 'react';

const CARD_DISPLAY_COUNT = 9;

/**
 * Displays a skeleton loader for the Player Awards Round By Round cards.
 *
 * @returns The Player Awards Round By Round cards.
 */
export const RoundByRoundSkeleton = () => (
    <div className="brownlow-round-by-round__content">
        {Array.from({ length: CARD_DISPLAY_COUNT }, (_, index) => card(index))}
    </div>
);

/**
 * Renders a table row.
 *
 * @returns {JSX.Element} The table row.
 */
const tableRow = (
    <tr className="brownlow-match-card__table-row">
        <td className="brownlow-match-card__table-column-number">
            <SkeletonLoader width={40} height={40} />
        </td>
        <td className="brownlow-match-card__table-column-name">
            <SkeletonLoader
                width={200}
                height={20}
                className="brownlow-match-card__skeleton-column-name"
            />
        </td>
        <td className="brownlow-match-card__table-column-total">
            <SkeletonLoader
                width={40}
                height={40}
                className="brownlow-match-card__skeleton-column-total"
            />
        </td>
    </tr>
);

/**
 * Renders a Round By Round card.
 *
 * @param {number} index  The index position value.
 * @returns {JSX.Element} The Round By Round card.
 */
const card = (index) => {
    return (
        <div
            className="brownlow-round-by-round__content-skeleton"
            key={`brownlow-round-by-round__content_${index}`}
        >
            <div className="brownlow-match-card brownlow-match-card--round-by-round">
                <div className="brownlow-match-card__table-skeleton-header">
                    <SkeletonLoader
                        width={640}
                        height={72}
                        className="brownlow-match-card__skeleton-header"
                    />
                </div>
                <table className="brownlow-match-card__table">
                    <tbody>
                        {tableRow}
                        {tableRow}
                        {tableRow}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
